import type { StaticImageData } from "next/image";
import Image from "next/image";
import { useRouter } from "next/router";
import { useCallback, useEffect, useState } from "react";

import { Input } from "../atoms/Input";
import { H1 } from "../atoms/typography/H1";
import { Button } from "../ui/button";

export const Password = ({
  bg,
  setV,
}: {
  bg: StaticImageData;
  setV: (v: string) => void;
}) => {
  const [password, setPassword] = useState("");
  const [error, setError] = useState(false);
  const { reload } = useRouter();

  const handleSubmit = useCallback(() => {
    setError(false);
    if (password !== process.env.NEXT_PUBLIC_DEV_KEY) {
      setError(true);
      return;
    }
    setV(password);
    void reload();
  }, [password, setV, reload]);

  useEffect(() => {
    // on enter key, trigger submit
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Enter") {
        handleSubmit();
      }
    };
    // biome-ignore lint/style/noRestrictedGlobals: <explanation>
    window.addEventListener("keydown", handleKeyDown);
    return () => {
      // biome-ignore lint/style/noRestrictedGlobals: <explanation>
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleSubmit]);
  return (
    <div className="container mx-auto h-[80vh] p-4">
      <div className="flex h-full flex-row items-center justify-center">
        <div className="mr-6 hidden max-w-xs md:block">
          <Image src={bg} width={559} height={826} alt="" placeholder="blur" />
        </div>

        <div className="max-w-md">
          <H1>Password Required</H1>
          <Input onChange={setPassword} placeholder="Enter password..." />
          <div className="flex items-center">
            <div className="pr-2">
              <Button onClick={handleSubmit}>Submit</Button>
            </div>
            {error && (
              <div className="text-red" role="alert">
                <p>
                  <span className="font-bold">Error. </span>
                  <span>Get outta here.</span>
                </p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
